import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Airport, NewAirport } from "src/app/domain/models/Airport";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export abstract class AirportGateway {
    abstract getAll(): Observable<Airport[]>
    abstract getOriginAirports(): Observable<Airport[]>
    abstract getDestinationAirportsByCountry(countryId: number): Observable<Airport[]>
    abstract create(airport: NewAirport): Observable<Airport>
    abstract getAllPaged(pageNumber: number, pageSize: number): Observable<PageResult<Airport>>
}
